'use client'

import { Button } from 'react-bootstrap'
import { usePathname } from 'next/navigation'

import Link from '@/components/Link'
import { isSamePath } from '@/utils/href'

const TABS = [
  { href: '/about/corporate-profile/board-of-directors', label: 'Board of Directors' },
  { href: '/about/corporate-profile/shariah-board', label: 'Shariah Board' },
  { href: '/about/corporate-profile/executive-management', label: 'Executive Management' }
]

function BODButton() {
  // Derive the active tab from the current route (not local state) so it stays
  // correct after navigation re-mounts the component.
  const pathname = usePathname()

  return (
    <div className="bod-button">
      {TABS.map(tab => (
        <Link key={tab.href} href={tab.href}>
          <Button className={isSamePath(pathname, tab.href) ? 'btn-item-active' : 'btn-item'}>
            {tab.label}
          </Button>
        </Link>
      ))}
    </div>
  )
}

export default BODButton
